import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { AddressRelatoryViewController, AddressRelatory } from "../../Screen/AddressRelatory/AddressRelatoryViewController";
import { AddressRelatoryViewModel } from '../../Screen/AddressRelatory/AddressRelatoryViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class AddressRelatoryCoordinator implements IndexCoordinatorDelegate, AddressRelatory {

    getRoute(): JSX.Element[] {
        return [
            this.routeAddressRelatory(),
        ]
    }

    private routeAddressRelatory(): JSX.Element {
        var viewModel = new AddressRelatoryViewModel()
        return (<ProtectedRoute requiredPermissions={['relatorios.endereco.*']} path="/:base/relatorios/endereco" exact={true} component={(props: any) => {
            return (<AddressRelatoryViewController
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
            />)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
}